module.exports = __webpack_public_path__ + "img/ios_safari_add_to_home.fb388255.png";